var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 100,
    viewBox: "0 0 114 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56.9959 0C60.1578 0 63.0748 1.67411 64.6781 4.41964L112.775 86.5625C114.401 89.3304 114.401 92.7455 112.82 95.5134C111.239 98.2812 108.277 100 105.093 100H8.89867C5.71446 100 2.75292 98.2812 1.17194 95.5134C-0.409029 92.7455 -0.386762 89.308 1.21648 86.5625L49.3137 4.41964C50.9169 1.67411 53.8339 0 56.9959 0ZM56.9959 28.5714C54.0343 28.5714 51.6517 30.9598 51.6517 33.9286V58.9286C51.6517 61.8973 54.0343 64.2857 56.9959 64.2857C59.9574 64.2857 62.34 61.8973 62.34 58.9286V33.9286C62.34 30.9598 59.9574 28.5714 56.9959 28.5714ZM64.1214 78.5714C64.1214 76.677 63.3707 74.8602 62.0344 73.5207C60.6981 72.1811 58.8857 71.4286 56.9959 71.4286C55.1061 71.4286 53.2937 72.1811 51.9574 73.5207C50.6211 74.8602 49.8704 76.677 49.8704 78.5714C49.8704 80.4658 50.6211 82.2826 51.9574 83.6222C53.2937 84.9617 55.1061 85.7143 56.9959 85.7143C58.8857 85.7143 60.6981 84.9617 62.0344 83.6222C63.3707 82.2826 64.1214 80.4658 64.1214 78.5714Z",
    fill: "#FFCA55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.872c6f5f50f1d025c2c80a46ba7f73f5.svg";
export { ForwardRef as ReactComponent };